import type { PathLink, RouteParams } from '@/hooks/usePathHelper'

type OrganizationIdParam = RouteParams[string]

function stripeFinancialLink(to: string, params: PathLink['params'] = {}): PathLink {
  return {
    to,
    params,
  }
}

export function stripeHubLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe', { orgId })
}

export function stripeUpgradeLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/upgrade', { orgId })
}

export function stripeOnboardingLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/onboarding', { orgId })
}

export function stripeAccountManagementLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/account-management', { orgId })
}

export function stripePayoutsLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/payouts', { orgId })
}

export function stripePaymentMethodsLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/payment-methods', { orgId })
}

export function stripePaymentsLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/payments', { orgId })
}

export function stripeDisputesLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/disputes', { orgId })
}

export function stripeCardReadersLink(orgId: OrganizationIdParam): PathLink {
  return stripeFinancialLink('/$orgId/settings/stripe/card-readers', { orgId })
}
